import { useEffect, useRef } from 'react';

export const useDidMountEffect = (func, deps) => {
    if (import.meta.env.MODE === "development") {
        const didMount = useRef(false);

        useEffect(() => {
            if (didMount.current)
                func();
            else
                didMount.current = true;
        }, deps);
    } else {
        // React em produção não renderiza múltiplas vezes como no localhost 
        // por conta que em localhost o React roda em strict mode. Não é necessário fazer
        // o código "if" acima para produção pois gera uma série de problemas 
        useEffect(() => { 
            func();
        }, deps)
    }
}